<template>
  <div class="volume-content">
    <template v-for="(box, boxIndex) in formatedVolumes">
      <div v-if="box.visible" class="volume-metrics-box" :key="boxIndex">
        <div class="volume-metrics-box-title">
          {{ box.title }} -
          <Tag type="info" size="small" effect="plain">
            <span style="color: black; margin-right: 5px">{{ box.totalVolume }}</span>
            <span>{{ box.title === 'ID based' ? 'IDs' : 'Users' }}</span>
          </Tag>
        </div>

        <div v-for="(row, rowIndex) in chunkAndFilterVolumes(box.volumes)" :key="rowIndex" class="l-flex-row volume-metrics-box-row">
          <template v-for="(volume, volumeIndex) in row">
            <div :key="volumeIndex" class="volume-box ghost" v-if="volume.ghost" />
            <Volume
              v-else
              :key="`${volumeIndex}-volume`"
              :icon="volume.icon"
              :label="volume.label"
              :value="volume.value"
              :volume-key="volume.key"
              :img="volume.img"
              :parent="parent"
            />
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { chunk } from 'lodash'
import { totalVolume, orderVolumes, formatNumber } from '@/utils/helpers'
import { Tag } from 'element-ui'
import Volume from '@/components/common/Volume'

export default {
    name: 'Volumes',

    components: {
        Volume,
        Tag,
    },

    props: {
        parent: {
            type: String,
            default: ''
        },
        volumes: {
            type: Object,
            default: () => ({})
        }
    },
    data: () => ({
        screenWidth: 2,
    }),

    computed: {
        // Call to state

        // ...mapState('account', {
        //     namespaces: state => state.namespaces,
        // }),

        // accountHaveCRMNamespace() {
        //     return this.namespaces.some((namespace) => namespace.type === 'CRM')
        // },

        ...mapState('data/settings', {
            xDeviceSetting: state => state.general.xdevice,
        }),

        ...mapState('ui/settings', {
            firstPartyCookieSettings: state => state.general.firstPartyCookie,
            providerUtiqActivated: state => state.general.providerUtiqActivated,
            providerFirstIdActivated: state => state.general.providerFirstIdActivated,
        }),

        ...mapGetters('ui/builder', ['getV2Formula']),

        showXDevice() {
            return this.xDeviceSetting
        },

        formatedVolumes() {

            const data = [
                {
                    title: 'ID based',
                    visible: true,
                    volumes: this.formatIdBasedVolumes(),
                    totalVolume: this.totalVolumesByCategory('idbased'),
                },
            ]

            if (this.showXDevice) {
                data.push({
                    title: 'Cross Device',
                    visible: this.showXDevice,
                    volumes: this.formatXDeviceVolumes(),
                    totalVolume: this.totalVolumesByCategory('xdevice'),
                })
            }

            return data
        },
    },

    methods: {
        formatIdBasedVolumes() {
            const idbasedVolumeData = {
                total_desktop: {
                    icon: 'cookie',
                    key: 'total_desktop',
                    label: 'Cookie',
                    value: this.calculateTotalVolume('total_desktop', 'idbased'),
                    visible: true
                },
                total_mobile: {
                    icon: 'mobile-volume',
                    key: 'total_mobile',
                    label: 'Mobile',
                    value: this.calculateTotalVolume('total_mobile', 'idbased'),
                    visible: true
                },
                total_crm: {
                    icon: 'crm-id',
                    key: 'total_crm',
                    label: 'CRM IDs',
                    value: this.calculateTotalVolume('total_crm', 'idbased'),
                    visible: true // this.accountHaveCRMNamespace
                },
                total_desktop_first: {
                    icon: 'cookie-1st',
                    key: 'total_desktop_first',
                    label: 'Cookie 1st',
                    value: this.calculateTotalVolume('total_desktop_first', 'idbased'),
                    visible: this.firstPartyCookieSettings
                },
                total_firstid: {
                    icon: 'first-id-volume',
                    key: 'total_firstid',
                    label: 'First-id',
                    value: this.calculateTotalVolume('total_firstid', 'idbased'),
                    visible: this.providerFirstIdActivated
                },
                total_utiq_mobile: {
                    icon: 'utiq',
                    key: 'total_utiq_mobile',
                    label: 'Utiq Mobile',
                    value: this.calculateTotalVolume('total_utiq_mobile', 'idbased'),
                    visible: this.providerUtiqActivated
                },
                total_utiq_home: {
                    icon: 'utiq',
                    key: 'total_utiq_home',
                    label: 'Utiq Home',
                    value: this.calculateTotalVolume('total_utiq_home', 'idbased'),
                    visible: this.providerUtiqActivated
                },
            }
            const idBasedOrder = orderVolumes('idbased')
            const idBasedVolumes = []
            idBasedOrder.forEach((key) => {
                if (idbasedVolumeData[key]) {
                    idBasedVolumes.push(idbasedVolumeData[key])
                }
            })

            return idBasedVolumes
        },


        formatXDeviceVolumes() {
            const xDeviceVolumeData = {
                total_users_desktop: {
                    icon: 'desktop-volume',
                    key: 'total_users_desktop',
                    label: 'Web',
                    value:  this.calculateTotalVolume('total_users_desktop', 'xdevice'),
                    visible: true
                },
                total_users_desktop_first: {
                    icon: 'desktop-first',
                    key: 'total_users_desktop_first',
                    label: 'Web 1st',
                    value: this.calculateTotalVolume('total_users_desktop_first', 'xdevice'),
                    visible: this.firstPartyCookieSettings
                },
                total_users_crm: {
                    icon: 'crm-id',
                    key: 'total_users_crm',
                    label: 'CRM IDs',
                    value: this.calculateTotalVolume('total_users_crm', 'xdevice'),
                    visible: true // this.accountHaveCRMNamespace
                },
                total_users_mobile: {
                    icon: 'app-volume',
                    key: 'total_users_mobile',
                    label: 'App',
                    value:  this.calculateTotalVolume('total_users_mobile', 'xdevice'),
                    visible: true
                },
                total_users_firstid: {
                    icon: 'first-id-volume',
                    key: 'total_users_firstid',
                    label: 'First-id',
                    value: this.calculateTotalVolume('total_users_firstid', 'xdevice'),
                    visible: this.providerFirstIdActivated
                },
                total_users_utiq_mobile: {
                    icon: 'utiq',
                    key: 'total_users_utiq_mobile',
                    label: 'Utiq Mobile',
                    value: this.calculateTotalVolume('total_users_utiq_mobile', 'xdevice'),
                    visible: this.providerUtiqActivated
                },
                total_users_utiq_home: {
                    icon: 'utiq',
                    key: 'total_users_utiq_home',
                    label: 'Utiq Home',
                    value: this.calculateTotalVolume('total_users_utiq_home', 'xdevice'),
                    visible: this.providerUtiqActivated
                },
            }

            const xDeviceOrder = orderVolumes('xdevice')
            const xDeviceVolumes = []

            xDeviceOrder.forEach((key) => {
                if (xDeviceVolumeData[key]) {
                    xDeviceVolumes.push(xDeviceVolumeData[key])
                }
            })

            return xDeviceVolumes
        },

        calculateTotalVolume(volume, type) {
            return totalVolume({
                type,
                volume,
                volumes: this.volumes,
            })
        },

        chunkAndFilterVolumes(volumes) {
            const filteredVolumes = volumes.filter(v => v.visible)
            const volumesChunkify = chunk(filteredVolumes, this.screenWidth)

            if (filteredVolumes.length % this.screenWidth !== 0) {
                volumesChunkify[volumesChunkify.length - 1].push({ ghost: true })
            }

            return volumesChunkify
        },
        resizeVolumeCard() {
            this.changeVolumeCardDisplay()
            window.addEventListener('resize', this.changeVolumeCardDisplay)
        },
        changeVolumeCardDisplay() {
            const width = document.body.clientWidth
            this.screenWidth = width > 1200 ? 2 : 3
        },
        totalVolumesByCategory(category) {
            let volume = 0
            let source = { ...this.volumes }

            if (category === 'idbased') {
                delete source.total_xdevice
            } else {
                source = source.total_xdevice
            }

            Object.keys(source ?? {}).forEach(key => {
                if (['total_doc', 'total_users'].includes(key)) return
                volume += source[key]
            })

            return formatNumber(volume)
        }
    },

    mounted() {
        if(this.parent === 'builder') {
            this.resizeVolumeCard()
        }
    }
}
</script>
